if (!customElements.get('email-signup-form')) {
  class EmailSignupForm extends HTMLElement {
    constructor() {
      super();

      this.endpoint = 'https://a.klaviyo.com/client/subscriptions/';
      this.revision = '2024-10-15';

      this.companyId = this.dataset.companyId;
      this.listId = this.dataset.listId;
      this.source = this.dataset.source;
      this.successText = this.dataset.successText;
      this.errorText = this.dataset.errorText;

      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[data-message]');
      this.hideOnSuccess = this.querySelectorAll('[data-hide-on-success]');

      this._handleSubmit = this.handleSubmit.bind(this);
    }

    connectedCallback() {
      if (!this.form) return;

      if (!this.companyId || !this.listId) {
        console.warn('email-signup-form: data-company-id and data-list-id are required.');
        return;
      }

      this.form.addEventListener('submit', this._handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this._handleSubmit);
    }

    get requestUrl() {
      return `${this.endpoint}?company_id=${encodeURIComponent(this.companyId)}`;
    }

    buildPayload(email) {
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.source || 'Custom form',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.listId
              }
            }
          }
        }
      };
    }

    setState(state) {
      if (state) {
        this.dataset.state = state;
      } else {
        delete this.dataset.state;
      }
    }

    setLoading(isLoading) {
      if (this.input) this.input.disabled = isLoading;
      if (this.button) this.button.disabled = isLoading;
    }

    hideContent() {
      this.form.hidden = true;

      this.hideOnSuccess.forEach((element) => {
        element.hidden = true;
      });
    }

    showMessage(text) {
      if (!this.message) return;

      this.message.textContent = text || '';
      this.message.hidden = !text;
    }

    async subscribe(email) {
      const response = await fetch(this.requestUrl, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          revision: this.revision
        },
        body: JSON.stringify(this.buildPayload(email))
      });

      if (!response.ok) {
        throw new Error(`Subscription failed with status ${response.status}`);
      }
    }

    async handleSubmit(event) {
      event.preventDefault();

      const email = this.input?.value.trim();

      if (!email) return;

      this.setState('loading');
      this.setLoading(true);
      this.showMessage('');

      try {
        await this.subscribe(email);

        this.hideContent();
        this.setState('success');
        this.showMessage(this.successText);
      } catch (error) {
        console.error(error);

        this.setState('error');
        this.showMessage(this.errorText);
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('email-signup-form', EmailSignupForm);
}
